import React from 'react'
import { TouchableOpacity, View, ViewStyle } from 'react-native'
import { color } from '../../theme'
import { iconStarCircled } from '../../assets'
import { RecallWheel } from '../recall-wheel'
import { SvgIcon } from '../svg-icon'
import { Text } from '../text'
import { Medal } from '../medal'

export const QuizResultPanels = (props: any) => {
  const { branding, result, enterpriseTier, score, quiz, quizType, setShowTooltip } = props
  return (
    <View style={{ flexDirection: 'row', marginBottom: 36 }}>
      <View
        style={{
          ...PANEL_CONTAINER,
          backgroundColor: branding.review_background,
          marginRight: quiz?.tutorial ? 0 : 10,
        }}
      >
        {quizType === 'post-test' ? (
          <View style={RESULT_PANEL_CONTENT}>
            <View style={RECALL_ROW}>
              <RecallWheel
                variant="medium-small"
                circleColour={color.green}
                iconColour={color.green}
                strokeColor={color.tint10}
                value={result?.pre_test_score}
                icon="check"
                style={{
                  ...SCORE_WHEEL,
                  marginRight: 16,
                  top: 9,
                  alignSelf: 'center',
                  left: -3,
                }}
              />
              <View style={{ alignSelf: 'center', flexDirection: 'column' }}>
                <Text
                  variant="label"
                  text={`${result?.pre_test_total_correct}/${result?.total_questions}`}
                  style={{ color: '#EFF0F670' }}
                />
                <Text variant="body2" text="Pre-Test" style={{ color: '#EFF0F650' }} />
              </View>
            </View>
            <View style={{ flexDirection: 'row', alignItems: 'center', left: -6 }}>
              <RecallWheel
                variant="medium-small"
                circleColour={color.green}
                iconColour={color.green}
                strokeColor={color.tint10}
                value={result?.post_test_score}
                icon="check"
                style={{ ...SCORE_WHEEL, marginRight: 16, top: 9, alignSelf: 'center' }}
              />
              <View style={{ alignSelf: 'center', flexDirection: 'column', left: 4 }}>
                <Text
                  variant="labelEmphasized"
                  text={`${result?.total_correct}/${result?.total_questions}`}
                  style={{ color: '#EFF0F6' }}
                />
                <Text variant="body2" text="Post-Test" style={{ color: '#EFF0F650' }} />
              </View>
            </View>
          </View>
        ) : quizType === 'reinforcement' || quizType === 'pre-test' || !enterpriseTier ? (
          <View style={RESULT_PANEL_CONTENT}>
            <RecallWheel
              variant="medium-small"
              circleColour={color.green}
              iconColour={color.green}
              strokeColor={color.tint10}
              value={score}
              icon="check"
              style={SCORE_WHEEL}
            />
            <Text
              variant="headline"
              text={`${result?.total_correct}/${result?.total_questions}`}
              style={{ alignSelf: 'center', color: branding.text_color }}
            />
            <View style={{ alignSelf: 'center', flexDirection: 'column' }}>
              <Text
                variant="body2Emphasized"
                text="Correct"
                style={{ color: `${branding.review_background_text}70` }}
              />
            </View>
          </View>
        ) : (
          <View style={RESULT_PANEL_CONTENT}>
            <TouchableOpacity onPress={() => setShowTooltip(true)}>
              <Medal
                style={{ marginBottom: 16 }}
                hideRecall={result?.medal_level !== null}
                recall={1}
                level={result?.medal_level}
                size={34}
              />
            </TouchableOpacity>
            <Text
              variant="headline"
              text={`${result?.total_correct}/${result?.total_questions}`}
              style={{ alignSelf: 'center', color: branding.review_background_text }}
            />
            <View style={{ alignSelf: 'center', flexDirection: 'column' }}>
              <Text
                variant="body2Emphasized"
                text="Correct"
                style={{ color: `${branding.review_background_text}70` }}
              />
            </View>
            {result?.medal_level && (
              <Text
                variant="body2Emphasized"
                tx={`Quiz.${result?.medal_level?.toLowerCase()}Medal`}
                style={{ color: color.darkenGrey }}
              />
            )}
          </View>
        )}
      </View>
      {!quiz?.tutorial && (
        <View
          style={{
            ...PANEL_CONTAINER,
            backgroundColor: branding.review_background,
            marginLeft: 10,
          }}
        >
          <View style={RESULT_PANEL_CONTENT}>
            <View style={{ marginBottom: 18 }}>
              <SvgIcon size={28} src={iconStarCircled} />
            </View>
            <Text
              variant="headline"
              text={result?.total_points}
              style={{ alignSelf: 'center', color: branding.review_background_text }}
            />
            <View style={{ flexDirection: 'row' }}>
              <Text
                variant="body2Emphasized"
                text={`+${result?.points_gained} `}
                style={{ color: '#FFDD64' }}
              />
              <Text
                variant="body2Emphasized"
                text="Points"
                style={{ color: `${branding.review_background_text}70` }}
              />
            </View>
          </View>
        </View>
      )}
    </View>
  )
}

const SCORE_WHEEL: ViewStyle = {
  marginBottom: 18,
  backgroundColor: 'rgba(255, 255, 255, 0.2)',
  borderRadius: 100,
}
const PANEL_CONTAINER: ViewStyle = {
  backgroundColor: 'rgba(25,30,38, .4)',
  alignItems: 'center',
  padding: 20,
  borderWidth: 3,
  borderColor: '#9098A330',
  borderRadius: 20,
  flex: 1,
  height: 155,
  justifyContent: 'center',
}
const RESULT_PANEL_CONTENT: ViewStyle = {
  alignSelf: 'center',
  alignItems: 'center',
  flex: 1,
  flexDirection: 'column',
  justifyContent: 'center',
}
const RECALL_ROW: ViewStyle = {
  flexDirection: 'row',
  marginBottom: 12,
  alignItems: 'center',
  left: -6,
}
